import { PostPurchaseMessage } from "../PostPurchaseMessages.props";

/** event post_purchase_message
 * product post_purchase_message
 * membership post_purchase_message */
type Item<T> = {
  name: string;
  post_purchase_message?: string;
} & T;

export const getPostPurchaseMessages = <T>(
  items: Array<Item<T>>
): Array<PostPurchaseMessage> => {
  const messages: Record<string, PostPurchaseMessage> = {};

  if (!items.length) return [];

  items.forEach((item) => {
    const { name, post_purchase_message } = item;

    if (post_purchase_message?.length) {
      // if postPurchaseMessage is a key then concat the name
      if (messages[post_purchase_message]) {
        messages[post_purchase_message].name += `, ${name}`;
      } else {
        // create a new entry
        messages[post_purchase_message] = {
          name: item.name,
          message: post_purchase_message,
        };
      }
    }
  });

  return Object.values(messages);
};
